import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setMessage } from "./message";

import MasterDataActionLogService from "../services/masterDataActionLog.service";

import { rejectedList } from "./listState";
const list = {
  list: [],
  pageSize: 25,
  page: 0,
  total: 0,
  nextPage: 0,
};

export const createMasterDataActionLog = createAsyncThunk(
  "MasterDataActionLog/create",
  async ({ masterDataActionLog }, thunkAPI) => {
    try {
      const data = await MasterDataActionLogService.createMasterDataActionLog(masterDataActionLog);
      return { data };
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage({ message: message, type: "error" }));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const updateMasterDataActionLog = createAsyncThunk(
  "MasterDataActionLog/update",
  async ({ masterDataActionLog }, thunkAPI) => {
    try {
      const data = await MasterDataActionLogService.updateMasterDataActionLog(masterDataActionLog);
      return { data };
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage({ message: message, type: "error" }));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const getMasterDataActionLog = createAsyncThunk(
  "MasterDataActionLog/get_list",
  async ({ search }, thunkAPI) => {
    try {
      const data = await MasterDataActionLogService.getMasterDataActionLog(search);
      return { elements: data };
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage({ message: message, type: "error" }));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const getMasterDataActionLogElement = createAsyncThunk(
  "MasterDataActionLog/get",
  async ({ id }, thunkAPI) => {
    try {
      const data = await MasterDataActionLogService.getMasterDataActionLogElement(id);
      return { element: data };
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage({ message: message, type: "error" }));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const getMasterDataActionLogUi = createAsyncThunk(
  "MasterDataActionLog/get_ui",
  async ({}, thunkAPI) => {
    try {
      const data = await MasterDataActionLogService.getMasterDataActionLogUi();
      return { ui: data };
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage({ message: message, type: "error" }));
      return thunkAPI.rejectWithValue();
    }
  }
);

const initialState = {
  data: list,
  loading: false,
  Ui: [],
};

const MasterDataActionLogSlice = createSlice({
  name: "MasterDataActionLog",
  initialState,

  extraReducers: {
    [getMasterDataActionLogUi.pending]: (state) => {
      state.loading = true;
    },
    [getMasterDataActionLogUi.fulfilled]: (state, action) => {
      state.Ui = action.payload.ui;
      state.loading = false;
    },
    [getMasterDataActionLogUi.rejected]: (state) => {
      state.Ui = null;
      state.loading = false;
    },

    [createMasterDataActionLog.pending]: (state) => {
      state.loading = true;
    },
    [createMasterDataActionLog.fulfilled]: (state, action) => {
      state.data.list.push(action.payload.data.data);
      state.data.total++;
      state.loading = false;
    },
    [createMasterDataActionLog.rejected]: (state) => {
      state.loading = false;
    },

    [getMasterDataActionLog.pending]: (state) => {
      state.loading = true;
    },
    [getMasterDataActionLog.fulfilled]: (state, action) => {
      state.data = action.payload.elements;
      state.loading = false;
    },
    [getMasterDataActionLog.rejected]: (state, action) => {
      state.data = rejectedList(state.data, action);
      state.loading = false;
    },

    [getMasterDataActionLogElement.pending]: (state) => {
      state.loading = true;
    },
    [getMasterDataActionLogElement.fulfilled]: (state, action) => {
      const newPayload = action.payload.element;
      const existingIndex = state.data.list.findIndex(
        (item) => item.id === newPayload.id
      );
      if (existingIndex >= 0) {
        state.data.list[existingIndex] = newPayload;
      } else {
        state.data.list.push(newPayload);
      }
      state.loading = false;
    },
    [getMasterDataActionLogElement.rejected]: (state) => {
      state.loading = false;
    },

    [updateMasterDataActionLog.fulfilled]: (state, action) => {
      const updated = state.data.list.map((item) => {
        if (item.id === action.payload.data.id) {
          return action.payload.data;
        }
        return item;
      });
      state.data.list = updated;
    },
  },
});

const { reducer } = MasterDataActionLogSlice;
export default reducer;
